import { RepositoryInterface } from '@/store/types';
import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { axiosProvider } from '@/store/provider';
import { TechAppUserInterface } from './TechAppUser';
import { refreshTokenInterceptorProvider } from '@/store/provider/intercept';

export class TechAppUserRepository implements RepositoryInterface {
  request: AxiosInstance;

  constructor(request: AxiosInstance) {
    this.request = request;
  }

  async all(config: AxiosRequestConfig = {}) {
    // App users endpoint now returns paginated results with filtering support
    return this.request.get<{
      total: number;
      results: TechAppUserInterface[];
      search: string;
    }>('appusers', config);
  }
}

const techAppUserRepository = new TechAppUserRepository(axiosProvider('permission', {}, {
  response: [refreshTokenInterceptorProvider()]
}));

export { techAppUserRepository };
